// extracted by mini-css-extract-plugin
module.exports = {"McsTextAreaBase":"McsTextBoxScroll_McsTextAreaBase__HKLp5","McsTextAreaTitle":"McsTextBoxScroll_McsTextAreaTitle__1uLHH","McsTextAreaBox":"McsTextBoxScroll_McsTextAreaBox__1l1Xw"};